import { useRouter } from "next/router";
import { isNonEmptyArray } from "@/utils/array-utils";
import { classNames } from "@/utils/classnames";

// ref: https://next-auth.js.org/configuration/pages#sign-in-page
// Note: try to provide some error messaging, but be vague b/c this could be malicious
const getMessageForError = (message: string): { message: string } => {
  switch (message) {
    case "CredentialsSignin":
    case "OAuthSignin":
      return {
        message:
          "An error occurred while validating the response from your provider. Please contact your IT administrators and Chalk to confirm that your login provider is set up correctly.",
      };
    case "OAuthCreateAccount":
    case "EmailCreateAccount":
      return {
        message: "An unknown error occurred while setting up your account.",
      };
    case "OAuthAccountNotLinked":
      return {
        message:
          "It looks like you have already logged in to Chalk using another provider first. Please use the provider you used originally.",
      };
    case "OAuthCallback":
    case "Callback":
    case "Default":
    default:
      return {
        message: "An unknown error occurred while processing your login.",
      };
  }
};

export const LoginFormError: React.FC = () => {
  const router = useRouter();
  const maybeError = router.query?.error;
  const maybeErrors = (Array.isArray(maybeError) ? maybeError : [maybeError]).filter(
    (error): error is string => typeof error === "string",
  );

  if (!isNonEmptyArray(maybeErrors)) {
    return null;
  }

  const errorInfo = maybeErrors.map(getMessageForError);

  return (
    <div className={"flex flex-col gap-2 py-2 text-xs"}>
      {errorInfo.map(({ message }, index) => {
        return (
          <p key={index} className={"text-red-500"}>
            {message}
          </p>
        );
      })}
      <p className={classNames("italic text-xs")}>
        <a href="mailto:support@chalk.ai" className="link">
          Contact Chalk for more support →
        </a>
      </p>
    </div>
  );
};
